import { fetcher } from 'services/helpers/responseHandler'

const enhanced = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary' },
  abortController
) =>
  fetcher.post(
    'factSubscriptions/completed',
    {
      fromDate,
      toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      kind
    },
    abortController
  )

const updated = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary' },
  abortController
) =>
  fetcher.post(
    'factSubscriptions/updated',
    {
      fromDate,
      toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      kind
    },
    abortController
  )

const added = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary' },
  abortController
) =>
  fetcher.post(
    'factSubscriptions/added',
    {
      fromDate,
      toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      kind
    },
    abortController
  )

const frontDeskPerformance = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary' },
  abortController
) =>
  fetcher.post(
    'factSubscriptions/frontDesk',
    {
      fromDate,
      toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      kind
    },
    abortController
  )

const stats = async (
  { fromDate, toDate, parentChainCode, kind = 'currentSubsidiary' },
  abortController
) =>
  fetcher.post(
    'factSubscriptions/stats',
    {
      fromDate,
      toDate,
      parentChainCode: parentChainCode === 'all' ? null : parentChainCode,
      kind
    },
    abortController
  )

const subscriptionsSnowflake = async (
  { fromDate, toDate, kind = 'currentSubsidiary' },
  abortController
) =>
  fetcher.get(
    'performance/subscriptions',
    {
      fromDate,
      toDate,
      kind
    },
    abortController
  )

const subscriptionStatsApi = {
  enhanced,
  updated,
  added,
  frontDeskPerformance,
  stats,
  subscriptionsSnowflake
}

export default subscriptionStatsApi
